import cn from 'classnames'
import { range } from 'lodash-es'
import React, { useEffect, useState } from 'react'

import DooerLogo from '../../../components/dooer-logo'

import styles from './gallery.module.scss'
import Heart from './heart'

function OLD_Gallery({
  className,
  variant,
  ...rest
}: React.HTMLAttributes<HTMLDivElement> & { variant?: 'brand' | 'free' }) {
  const [heartsVisible, setHeartsVisible] = useState(true)
  useEffect(() => {
    const id = 'embed-social-gallery'
    if (!window.document.getElementById(id)) {
      const s = window.document.createElement('script')
      s.async = true
      s.id = id
      s.src = 'https://embedsocial.com/js/iframe.js'
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore - Call global function provided by imported script
      s.onload = () => window.iFrameResize()
      window.document.head.appendChild(s)
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (typeof (window as any).iFrameResize === 'function') {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ;(window as any).iFrameResize()
    }
  })

  return (
    <div
      className={cn([styles.container, variant === 'free' && styles.free, className])}
      onMouseEnter={() => setHeartsVisible(false)}
      onMouseLeave={() => setHeartsVisible(true)}
      {...rest}
    >
      <div className={cn(styles.hearts, heartsVisible && styles.heartsVisible)}>
        <div className={styles.heartsInner}>
          {range(9).map((i) => (
            <Heart key={i} />
          ))}
        </div>
      </div>
      <a className={styles.title} href="https://www.instagram.com/Dooerhq/" rel="noopener noreferrer" target="_blank">
        <DooerLogo className={styles.socialLogo} theme="free" variant="circle" />
        {'DooerHQ'}
      </a>
      <iframe
        className={styles.iframe}
        scrolling="no"
        src="https://embedsocial.com/facebook_album/pro_instagram/5c2fb2401bbfd0a42af981c2a9e923885b6cb9e2"
        title="Dooer Instagram gallery"
      />
    </div>
  )
}

export default (_: React.HTMLAttributes<HTMLDivElement> & { variant?: 'brand' | 'free' }) => null
export { OLD_Gallery }
